"use client";

import { useState } from "react";
import type { DayCard } from "@/lib/days";

export default function FlashCard({ day }: { day: DayCard }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="flip-card"
      onClick={() => setFlipped((f) => !f)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") setFlipped((f) => !f);
      }}
      aria-label={`Dag ${day.id}, ${day.city}. Klicka för att vända kortet.`}
    >
      <div className={`flip-card-inner ${flipped ? "flipped" : ""}`}>
        {/* FRONT */}
        <div className="flip-card-face flip-card-front">
          <div className="card-collage" data-city={day.city} />
          <div className="card-front-overlay">
            {day.tag && <span className="card-tag">{day.tag}</span>}
            <span className="card-daynum">Dag {day.id}</span>
            <h2 className="card-date">
              {day.date} <span className="card-weekday">{day.weekday}</span>
            </h2>
            <h3 className="card-city">{day.city}</h3>
            <p className="card-title">{day.title}</p>
            <span className="card-hint">Klicka för detaljer →</span>
          </div>
        </div>

        {/* BACK */}
        <div className="flip-card-face flip-card-back">
          <div className="card-back-inner">
            <h3 className="card-back-city">
              {day.city} <span className="card-back-date">{day.date}</span>
            </h3>

            {day.dosList.length > 0 && (
              <div className="card-section">
                <h4>Göra</h4>
                <ul>
                  {day.dosList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {day.eatList.length > 0 && (
              <div className="card-section">
                <h4>Äta</h4>
                <ul>
                  {day.eatList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {day.brainstormList.length > 0 && (
              <div className="card-section card-brainstorm">
                <h4>💡 Spånat</h4>
                <ul>
                  {day.brainstormList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {day.restaurants && day.restaurants.length > 0 && (
              <div className="card-section card-restaurants">
                <h4>🍜 Sparade restauranger</h4>
                {day.restaurants.map((group, i) => (
                  <details key={i} className="restaurant-area">
                    <summary>
                      {group.area} <span className="restaurant-count">({group.items.length})</span>
                    </summary>
                    <ul>
                      {group.items.map((item, j) => (
                        <li key={j}>{item}</li>
                      ))}
                    </ul>
                  </details>
                ))}
              </div>
            )}

            <div className="card-footer">
              {day.hotel ? (
                <span className={day.hotelBooked ? "hotel-booked" : "hotel-unbooked"}>
                  🏨 {day.hotel}
                </span>
              ) : (
                <span className="hotel-unbooked">🏨 Hotell ej bokat</span>
              )}
              {day.notes && <span className="card-notes">{day.notes}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
